export default {
  ONE_TIME: "PURCHASE_OPTIONS.ONE_TIME",
  SUBSCRIPTION: "PURCHASE_OPTIONS.SUBSCRIPTION"
};



// WEBPACK FOOTER //
// ./src/buy/purchase-options.js